import { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from './useAuth';
import Login from '../../views/auth/Login';
import Error from '../common/Error';

const AuthGuard = (props) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [requestedLocation, setRequestedLocation] = useState(null);

  useEffect(() => {
    if (auth?.user?.scope === '2fa_access') {
      navigate('/auth/2fa');
    } else if (auth?.user?.scope === 'full_access' && auth.isAuthenticated) {
      navigate('/home');
    }
  }, [auth]);

  if (localStorage.getItem('accessToken') == null) {
    return <Login />;
  }

  if (!auth.isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
      return <Error />;
    }

    return <Login />;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
